import { useEffect, useState } from "react";
import {authorize_net_accept_js} from "../services/common.services";

export function useAcceptJS() {
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if ((window as any).Accept) {
            setLoaded(true);
            return;
        }

        const existing = document.querySelector(`script[src="${authorize_net_accept_js}"]`);
        if (existing) {
            existing.addEventListener("load", () => setLoaded(true));
            return;
        }

        const script = document.createElement("script");
        script.src = authorize_net_accept_js;
        script.async = true;

        script.onload = () => setLoaded(true);
        script.onerror = () => setError("Failed to load Accept.js script.");

        document.body.appendChild(script);
    }, []);

    return { loaded, error, accept: (window as any).Accept };
}
